import React from "react";
import "./App.css";

function App() {
  const [iframe, setIframe] = React.useState("");
  React.useEffect(() => {
    const searchArr = window.location.search
      ? window.location.search.split("=")
      : [];
    if (searchArr && searchArr[0] === "?url" && searchArr[1]) {
      const iframeLink = window.location.search
        .replace("?url=", "")
        .replace("url=", "");
      setIframe(iframeLink);
    }
  }, [window.location.search]);

  return (
    <>
      {iframe && (
        <iframe
          id="livebox-iframe"
          title="ライブコマースできるくん"
          width="100%"
          height="700"
          src={iframe}
        ></iframe>
      )}
      <div className="App">
        <header className="App-header">
          <h2>Loading Iframe</h2>
          <iframe
            src="https://minhlq-0928.github.io/reactjs-amplify"
            title="Iframe GA Testing"
            width="100%"
            height="500"
          ></iframe>
        </header>
      </div>
    </>
  );
}

export default App;
